module.exports = __webpack_public_path__ + "img/pc_banner.442a6982.jpg";